const PwaStatus = {
  Install: 1,
  Installing: 2,
  Installed: 3,
};

export default PwaStatus;

